import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import logo from "../../../assets/images/logo.png"
import Ellipse from "../../../assets/images/Ellipse.png"

function SignupLeftSideCard() {
    return (
        <div className="relative h-full w-full bg-[#0A0F1C] flex items-center font-inter overflow-hidden rounded-md">
            <div className="w-full h-full flex p-10 sm:p-6 md:p-8 lg:p-10">
                <div className="flex flex-col justify-center items-start w-full h-full bg-transparent">
                    <img
                        src={Ellipse}
                        alt="Background Graphic"
                        className="absolute top-0 left-0 w-40 sm:w-56 md:w-64 lg:w-72 pointer-events-none select-none opacity-20"
                    />

                    <div className="w-full max-w-[90%] sm:max-w-[400px] md:max-w-[450px] lg:max-w-[500px] text-white z-10">
                        <div className="flex items-center gap-2 mb-6 sm:mb-8 md:mb-10 lg:mb-12">
                            <img
                                src={logo}
                                alt="DataCraft Logo"
                                className="w-[140px] sm:w-[170px] md:w-[200px] lg:w-[220px] object-contain invert brightness-0"
                            />
                        </div>

                        <h2 className="font-bold leading-snug mb-4 sm:mb-5 md:mb-6 text-[24px] sm:text-[28px] md:text-[36px] lg:text-[40px]">
                            The Smarter Way <br /> to Manage <br /> Financial Data
                        </h2>

                        <p className="text-gray-300 mb-6 sm:mb-8 md:mb-10 lg:mb-12 text-[14px] sm:text-[15px] md:text-[16px] leading-relaxed">
                            With Data Craft, you can organize, analyze, and gain insights from
                            your financial sheets—all in one place.
                        </p>

                        <Swiper
                            modules={[Autoplay, Pagination]}
                            autoplay={{ delay: 2000, disableOnInteraction: false }}
                            pagination={{ clickable: true }}
                            loop={true}
                            className="w-full max-w-full sm:max-w-lg"
                        >
                            {[1, 2, 3].map((i) => (
                                <SwiperSlide key={i}>
                                    <div className="bg-gradient-to-bl from-[#353c42] via-[#353c42] to-[#2b3035] p-3 sm:p-4 md:p-5 rounded-xl shadow-xl shadow-black/40 border border-white/10 h-[180px] sm:h-[200px] md:h-[220px] lg:h-[240px] flex flex-col justify-between">
                                        <i className="text-[13px] sm:text-[14px] md:text-[15px] text-gray-200 leading-snug line-clamp-3 sm:line-clamp-4 mb-2">
                                            Data Craft has completely transformed how we handle financial reporting. Its intuitive interface and powerful automation tools save us hours of manual work every week. We now have real-time visibility into our financial health, enabling smarter and faster decisions.
                                        </i>
                                        <div className="flex items-center gap-2 sm:gap-3">
                                            <img
                                                src="https://randomuser.me/api/portraits/women/44.jpg"
                                                alt="profile"
                                                className="w-10 h-10 sm:w-11 sm:h-11 md:w-12 md:h-12 rounded-lg ring-2 ring-white/20"
                                            />
                                            <div className="flex flex-col inline-block align-bottom justify-center text-left">
                                                <span className="font-medium text-white text-[15px] sm:text-[16px] md:text-[18px] lg:text-[20px] leading-tight">
                                                    Sarah Mitchelle
                                                </span>
                                                <p className="text-gray-400 text-[11px] sm:text-[12px] md:text-[13px] lg:text-[15px] leading-tight">
                                                    CFO Global Finance Corp
                                                </p>
                                            </div>
                                        </div>

                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default SignupLeftSideCard;